import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect } from 'react';
import { actionSetLayerFeatures } from '@tmapy/mapcore';
import { LAYER_IDS } from '@tmapy/config';
import { RadioBtnGroup } from '@tmapy/style-guide';
import { useMessage } from '@tmapy/intl';
import { actionSetTab } from '../actions';
import { tabMessages } from '../messages';
import { SearchTab } from './SearchTab';
export const defaultGetMapPadding = () => [20, 20, 20, 260];
export const Search = React.memo(({ token, isActive, tabs, activeTabId, highlightedFeatureIds, getMapPadding, dispatch }) => {
    const formatMessage = useMessage();
    const handleTabChange = useCallback((e) => {
        dispatch(actionSetTab(e.target.value));
    }, [dispatch]);
    useEffect(() => {
        if (!isActive) {
            dispatch(actionSetLayerFeatures(`${LAYER_IDS.SEARCH}-${activeTabId}`, []));
        }
    }, [dispatch, isActive]);
    const activeTab = tabs.find((tab) => tab.id === activeTabId);
    const items = tabs.map((tab) => ({
        label: formatMessage.fallback([tabMessages[tab.id], `search.${tab.id}`]) ?? tab.id,
        value: tab.id,
    }));
    return (_jsxs(_Fragment, { children: [tabs.length > 1 && (_jsx("div", { className: 'sg-a-mt-2 sg-a-px-2', children: _jsx(RadioBtnGroup, { items: items, onChange: handleTabChange, value: activeTabId }) })), activeTab && (_jsx(SearchTab, { token: token, tab: activeTab, getMapPadding: getMapPadding ?? defaultGetMapPadding, dispatch: dispatch, isActive: isActive, highlightedFeatureIds: highlightedFeatureIds }, activeTabId))] }));
});
//# sourceMappingURL=Search.js.map